import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { supabase } from './supabaseClient';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

// Material Dashboard 2 React example components
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from "examples/Footer";
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AddTheatreOwner() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [theatreData, setTheatreData] = useState();
    const [selectedTheatreId, setSelectedTheatreId] = useState();
    const navigate = useNavigate();

    // useEffect(() => {
    //     fetchTheatreData()
    // }, [])

    // const fetchTheatreData = async () => {
    //     try {
    //         const { data, error } = await supabase.from('theatres').select('*');
    //         if (data) {
    //             setTheatreData(data);
    //         }
    //         if (error) throw error;
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const onSubmit = async (values, { resetForm }) => {
        try {
            const response = await axios.post(`${apiUrl}auth-service/auth`, values);
            if (response.data?.success && response.data?.data) {
                toast.info(response.data.message || 'User created successfully');
            } else {
                throw new Error("Failed to create user");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        } finally {
            resetForm();
            setTimeout(() => {
                navigate(-1);
            }, 1500);
        }
    };

    const newUser = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            phone: Yup.string()
                .required('Required')
                .matches(/^\+?[1-9]\d{1,14}$/, 'Mobile number is not valid')
                .min(10, 'Not a valid phone number')
                .max(15, 'Not a valid phone number'),
            email: Yup.string().required('Email is required').email('Enter a valid email'),
        }),
        onSubmit,
    });

    return (
        <DashboardLayout><DashboardNavbar /> <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <form onSubmit={newUser.handleSubmit}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                            >
                                <MDTypography variant="h6" color="white">
                                    Add New Theatre Owner
                                </MDTypography>
                            </MDBox>
                            <MDBox p={2}>
                                <MDBox p={1}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        id="firstName"
                                        label="First Name"
                                        name="firstName"
                                        value={newUser.values.firstName}
                                        onChange={newUser.handleChange}
                                        onBlur={newUser.handleBlur}
                                        error={newUser.touched.firstName && Boolean(newUser.errors.firstName)}
                                        helperText={newUser.touched.firstName && newUser.errors.firstName} />
                                </MDBox>
                                <MDBox p={1}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        id="lastName"
                                        label="Last Name"
                                        name="lastName"
                                        value={newUser.values.lastName}
                                        onChange={newUser.handleChange}
                                        onBlur={newUser.handleBlur}
                                        error={newUser.touched.lastName && Boolean(newUser.errors.lastName)}
                                        helperText={newUser.touched.lastName && newUser.errors.lastName} />
                                </MDBox>
                                <MDBox p={1}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        id="phone"
                                        label="Phone"
                                        name="phone"
                                        value={newUser.values.phone}
                                        onChange={newUser.handleChange}
                                        onBlur={newUser.handleBlur}
                                        error={newUser.touched.phone && Boolean(newUser.errors.phone)}
                                        helperText={newUser.touched.phone && newUser.errors.phone} />
                                </MDBox>
                                <MDBox p={1}>
                                    <TextField fullWidth
                                        variant="outlined"
                                        id="email"
                                        label="Email"
                                        name="email"
                                        value={newUser.values.email}
                                        onChange={newUser.handleChange}
                                        onBlur={newUser.handleBlur}
                                        error={newUser.touched.email && Boolean(newUser.errors.email)}
                                        helperText={newUser.touched.email && newUser.errors.email} />
                                </MDBox>
                                <MDBox p={1}>
                                    <TextField fullWidth
                                        variant="outlined"
                                        id="password"
                                        label="Password"
                                        name="password"
                                        value={newUser.values.password}
                                        onChange={newUser.handleChange}
                                        onBlur={newUser.handleBlur}
                                        error={newUser.touched.password && Boolean(newUser.errors.password)}
                                        helperText={newUser.touched.password && newUser.errors.password} />
                                </MDBox>
                                {/* <MDBox p={1}>
                                    <FormControl fullWidth>
                                        <InputLabel>Select User Role</InputLabel>
                                        <Select
                                            label="Select User Role"
                                            name="userRole"
                                            value={newUser.values.userRole}
                                            onChange={newUser.handleChange}
                                            onBlur={newUser.handleBlur}
                                            error={newUser.touched.userRole && Boolean(newUser.errors.userRole)}
                                            helperText={newUser.touched.userRole && newUser.errors.userRole}
                                            sx={{ height: '45px' }}
                                        >
                                            <MenuItem value="theatreOwner">Theatre Owner</MenuItem>
                                        </Select>
                                    </FormControl>
                                </MDBox>
                                <MDBox p={1}>
                                    <FormControl fullWidth mb={3}>
                                        <InputLabel>Select Theatre</InputLabel>
                                        <Select
                                            label="Select Theatre"
                                            value={selectedTheatreId}
                                            onChange={(e) => setSelectedTheatreId(e.target.value)}
                                            sx={{ height: '45px', mb: 3 }}
                                        >
                                            {theatreData && theatreData.map((theatre) => (
                                                <MenuItem key={theatre.id} value={theatre.id}>
                                                    {theatre.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </MDBox> */}
                                <MDBox p={1}>
                                    <MDButton color='info' type='submit'>Save</MDButton>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </form>
                </Grid>
            </Grid>
        </MDBox>
            <Footer />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </DashboardLayout>
    )
}